import { defaultSingleObjectState } from "utils/constants";
import * as types from "./types";
import { extractStatus, handleReduxAction } from "helpers/reduxHelpers";

const defaultPayload = {
  data: [],
  errors: [],
};

const initalState = {
  user: defaultSingleObjectState,
};

const authReducer = (state = initalState, { type, payload = defaultPayload }: any) => {
  const status = extractStatus(type);

  switch (type) {
    case types.LOGIN.request:
    case types.LOGIN.success:
    case types.LOGIN.error:
      return handleReduxAction(state, payload, status, "user");

    default:
      return state;
  }
};

export default authReducer;
